<template>
  <ul>
    <li :class="actvIndex == 1 ? 'is-active' : ''" @click="handSelect(1)">
      今日
    </li>
    <li :class="actvIndex == 2 ? 'is-active' : ''" @click="handSelect(2)">
      近七天
    </li>
    <li :class="actvIndex == 3 ? 'is-active' : ''" @click="handSelect(3)">
      本月
    </li>
    <li :class="actvIndex == 4 ? 'is-active' : ''" @click="handSelect(4)">
      本年
    </li>
  </ul>
</template>

<script>
  export default {
    name: 'choice',
    data() {
      return {
        actvIndex: 3,
      }
    },
    methods: {
      handSelect(i) {
        this.actvIndex = i
      },
    },
  }
</script>

<style scoped lang="scss">
  ul {
    height: 29px;
    list-style: none;
    display: flex;
    justify-content: flex-end;
    color: #15a983;
    cursor: pointer;

    li {
      margin-right: 30px;
      white-space: nowrap;
    }

    .is-active {
      border-bottom: 1px solid #ffc600;
      padding-bottom: 7px;
      position: relative;
      color: #fff;

      &::after {
        content: '';
        width: 0;
        height: 0;
        border-bottom: 5px solid #ffc600;
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        position: absolute;
        bottom: 0px;
        left: 37%;
      }
    }
  }
</style>
